<template>
  <div>
    <LoadingPage v-if="loading" />

    <div class="metrics-page" v-else>
      <div class="metrics-grid" v-if="dep !== 'customer'">
        
        <div class="metric-card">
          <div class="icon-wrapper">
            <i class="bi bi-people-fill"></i>
          </div>
          <div class="metric-details">
            <h5>{{ $t("customers") }}</h5>
            <div class="metric-counter">
              <span class="label">{{ $t("numbers") }}:</span>
              <span class="value">{{ costomer }}</span>
            </div>
          </div>
        </div>

        <div class="metric-card">
          <div class="icon-wrapper">
            <i class="bi bi-reply-all-fill"></i>
          </div>
          <div class="metric-details">
            <h5>{{ $t("suppliers") }}</h5>
            <div class="metric-counter">
              <span class="label">{{ $t("numbers") }}:</span>
              <span class="value">{{ suppliers }}</span>
            </div>
          </div>
        </div>

        <div class="metric-card">
          <div class="icon-wrapper">
            <i class="bi bi-file-earmark-medical-fill"></i>
          </div>
          <div class="metric-details">
            <h5>{{ $t("invoices") }} {{ $t("sales") }}</h5>
            <div class="metric-counter">
              <span class="label">{{ $t("numbers") }}:</span>
              <span class="value">{{ invoices }}</span>
            </div>
          </div>
        </div>

        <div class="metric-card">
          <div class="icon-wrapper">
            <i class="bi bi-credit-card-2-front-fill"></i>
          </div>
          <div class="metric-details">
            <h5>{{ $t("bills") }}</h5>
            <div class="metric-counter">
              <span class="label">{{ $t("numbers") }}:</span>
              <span class="value">{{ bills }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import LoadingPage from "../components/LoadingPage.vue";

export default {
  components: { LoadingPage },
  props: ["css"],
  data() {
    return {
      loading: false,
      costomer: 0,
      suppliers: 0,
      invoices: 0,
      bills: 0,
      salles: "",
      dep: store.state.typeofuser,
    };
  },
  async created() {
    try {
      this.loading = true;
      const result = await axios.get(`/reports/homesummary`);
      if (result.status === 200) {
        this.costomer = result.data.customer?.[0]?.count || 0;
        this.suppliers = result.data.suppliers?.[0]?.count || 0;
        this.invoices = result.data.invoice?.[0]?.count || 0;
        this.bills = result.data.bills?.[0]?.count || 0;
        this.salles = result.data.salles || "";
      }
    } catch (error) {
      console.error("Dashboard summary pipeline initialization failed:", error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped lang="scss">
.metrics-page {
  direction: v-bind("css.EN");
  font-family: "Cairo", sans-serif;
  padding: 12px;
}

/* Fluid responsive CSS Grid architecture layout */
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
  width: 100%;
}

/* Individual Metric Cards Styling */
.metric-card {
  background: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  /* Structural wrapper for graphic container */
  .icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: v-bind("css.color");
    opacity: 0.9;
    flex-shrink: 0;
    
    // Target inner standard bootstrap icons explicitly
    i {
      font-size: 24px;
      color: #ffffff;
    }
  }

  /* Metric Description Context Layouts */
  .metric-details {
    margin-left: 16px;
    margin-right: 16px;
    flex-grow: 1;

    h5 {
      font-size: 15px;
      font-weight: 700;
      color: #718096;
      margin: 0 0 6px 0;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .metric-counter {
      display: flex;
      align-items: baseline;
      gap: 6px;

      .label {
        font-size: 13px;
        color: #a0aec0;
      }

      .value {
        font-size: 20px;
        font-weight: 700;
        color: #1a202c;
      }
    }
  }
}

/* Responsive Adaptive Viewports Breakpoints */
@media screen and (max-width: 1200px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 576px) {
  .metrics-page {
    padding: 6px 0;
  }
  
  .metrics-grid {
    grid-template-columns: 1fr;
    grid-gap: 12px;
  }

  .metric-card {
    padding: 16px;
    
    .icon-wrapper {
      width: 48px;
      height: 48px;
      
      i {
        font-size: 20px;
      }
    }

    .metric-details {
      h5 {
        font-size: 14px;
      }
      
      .metric-counter .value {
        font-size: 18px;
      }
    }
  }
}
</style>